import { render } from "./PrintBarcodePage.vue?vue&type=template&id=1b681f9b&scoped=true&ts=true"
import script from "./PrintBarcodePage.vue?vue&type=script&lang=ts"
export * from "./PrintBarcodePage.vue?vue&type=script&lang=ts"

import "./PrintBarcodePage.vue?vue&type=style&index=0&id=1b681f9b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b681f9b"]])

export default __exports__